<template>
  <div class="va-pay-pc">
    <div class="va-card">
      <div class="va-header">
        <img v-if="isAO" :src="expressLogo" class="va-title-logo" alt="Bank Transfer" />
        <div v-else class="va-title">{{ $t('text_bank_transfer') }}</div>
      </div>

      <div v-if="!isAccountSubmitted || (!isAO && !shouldShowNumberInput)" class="va-amount-box">
        <div class="va-amount-label">{{ isAO ? $t(vaAmountLabelKey) : 'Amount' }}</div>
        <div class="va-amount-value">
          <span>{{ countryInfo?.currencyCode || 'AOA' }}</span>
          <span class="va-amount-num">{{ formattedPaymentAmount }}</span>
        </div>
      </div>

      <!-- AO 国家：仅在收银台页（已提交后）才显示三排 -->
      <div v-if="isAO && isAccountSubmitted" class="va-info-card-ao">
        <div class="va-info-item-ao">
          <div class="va-info-item-ao-content">
            <div class="va-info-label">{{ $t(vaAmountLabelKey) }}</div>
            <div class="va-info-value va-info-highlight">
              {{ formattedPaymentAmount }}
            </div>
          </div>
        </div>
        <div class="va-info-item-ao" @click="onCopy(vaAccount)">
          <div class="va-info-item-ao-content">
            <div class="va-info-label">{{ $t('text_va_reference') }}</div>
            <div class="va-info-value va-info-highlight va-info-value-copyable">
              <span class="va-info-value-text">{{ vaAccount || '--' }}</span>
            </div>
          </div>
          <img class="va-info-copy-btn" src="@/assets/copy.png" alt="copy" />
        </div>
        <div class="va-info-item-ao" @click="onCopy(bankCode)">
          <div class="va-info-item-ao-content">
            <div class="va-info-label">{{ $t('text_va_institution_id') }}</div>
            <div class="va-info-value va-info-value-copyable">
              <span class="va-info-value-text">{{ bankCode || '--' }}</span>
            </div>
          </div>
          <img class="va-info-copy-btn" src="@/assets/copy.png" alt="copy" />
        </div>
      </div>

      <!-- 非 AO 国家：保持原 VA 卡 -->
      <div
        v-if="!isAO && !shouldShowNumberInput"
        class="va-info-card"
      >
        <div class="va-info-item" @click="onCopy(vaAccount)">
          <div class="va-info-label">{{ $t('text_va_account') }}</div>
          <div class="va-info-value va-info-highlight">{{ vaAccount || '--' }}</div>
          <div class="va-info-copy">{{ $t('text_va_click_to_copy') }}</div>
        </div>
        <div class="va-info-divider"></div>
        <div class="va-info-item" @click="onCopy(bankCode)">
          <div class="va-info-label">{{ $t('text_va_bank_code') }}</div>
          <div class="va-info-value">{{ bankCode || '--' }}</div>
          <div class="va-info-copy">{{ $t('text_va_click_to_copy') }}</div>
        </div>
      </div>

      <div class="va-timer" v-if="hr && (!shouldShowNumberInput || isAccountSubmitted)">
        <span>{{ $t('text_remaining_time') }}: </span>
        <span class="va-timer-value">{{ hr }}:{{ min }}:{{ sec }}</span>
      </div>

      <div v-if="isAccountSubmitted && isAO" class="va-multicaixa-hint">
        {{ $t('text_va_multicaixa_hint') }}
      </div>

      <div
        v-if="shouldShowNumberInput && !isAccountSubmitted"
        class="computer_pay_container_step_account"
      >
        <div class="computer_pay_container_step_account_input_box">
          <div class="computer_pay_container_step_233">+{{ countryInfo?.phoneCode }}</div>
          <input
            v-model="paymentAccount"
            class="computer_pay_container_step_account_input"
            type="text"
            :maxlength="phoneMaxLength"
            :placeholder="$t('text_please_enter_your_actual_payment_account')"
          />
        </div>
        <div
          @click="paymentAccountSubmit"
          class="computer_pay_container_step_account_submit"
          :class="{ 'is-loading': paymentAccountSubmitting }"
        >
          <div class="computer_pay_container_step_account_submit_text">
            {{ $t('text_confirm') }}
          </div>
        </div>
      </div>

      <div class="va-notice">
        {{ $t('text_va_notice') }}
      </div>
    </div>
  </div>
</template>

<script>
import logic from "./index.js";
export default {
  name: "LinkedPayVAComputer",
  mixins: [logic],
};
</script>

<style lang="scss" scoped>
.va-pay-pc {
  max-width: 480px;
  margin: 40px auto;
}

.va-card {
  background: #fff;
  border-radius: 16px;
  padding: 40px 32px;
  box-shadow: 0 2px 20px rgba(0,0,0,0.08);
}

.va-header {
  text-align: center;
  margin-bottom: 28px;
}

.va-title {
  font-size: 22px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.va-title-logo {
  max-width: 200px;
  height: auto;
  object-fit: contain;
  display: inline-block;
}

.va-desc {
  font-size: 14px;
  color: #888;
  line-height: 1.4;
}

.va-amount-box {
  text-align: center;
  margin-bottom: 32px;
}

.va-amount-label {
  font-size: 14px;
  color: #888;
  margin-bottom: 4px;
}

.va-amount-value {
  font-size: 16px;
  color: #524535;
  font-weight: 500;
}

.va-amount-num {
  font-size: 24px;
  color: #DC811D;
  margin-left: 6px;
}

.va-multicaixa-hint {
  font-size: 13px;
  color: #666;
  line-height: 1.5;
  margin: 16px 0 24px;
  text-align: center;
}

.va-info-card-ao {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #f0f0f0;
  overflow: hidden;
  margin-bottom: 24px;
}

.va-info-item-ao {
  padding: 20px 24px;
  display: flex;
  align-items: center;
  gap: 16px;
  cursor: pointer;
  position: relative;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: #fafafa;
  }
}

.va-info-item-ao-content {
  flex: 1;
  min-width: 0;
}

.va-info-label {
  font-size: 12px;
  color: #999;
  margin-bottom: 6px;
}

.va-info-value {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  word-break: break-all;
}

.va-info-highlight {
  font-size: 18px;
  color: #DC811D;
  font-weight: 600;
}

.va-info-value-copyable {
  font-size: 16px;
}

.va-info-value-text {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.va-info-copy-btn {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  margin-left: auto;
}

.va-info-card {
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 24px;
}

.va-info-item {
  padding: 20px 24px;
  cursor: pointer;
  transition: background 0.15s;

  &:hover {
    background: #fafafa;
  }
}

.va-info-copy {
  font-size: 11px;
  color: #ccc;
  margin-top: 4px;
}

.va-info-divider {
  height: 1px;
  background: #f0f0f0;
  margin: 0 24px;
}

.va-timer {
  text-align: center;
  font-size: 13px;
  color: #888;

  .va-timer-value {
    font-weight: 600;
    color: #DC811D;
  }
}

.va-notice {
  text-align: center;
  margin-top: 20px;
  font-size: 12px;
  color: #aaa;
  line-height: 1.5;
}

.computer_pay_container_step_account {
  box-sizing: border-box;
  margin-top: 16px;

  .computer_pay_container_step_account_input_box {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid #cccccc;
    padding: 4px 6px;
    padding-right: 8px;
    box-sizing: border-box;
  }

  .computer_pay_container_step_233 {
    width: 100px;
    font-size: 20px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #dc811d;
    text-align: center;
  }

  .computer_pay_container_step_account_input {
    background: transparent;
    margin-right: 10px;
    padding-left: 18px;
    width: 100%;
    height: 100%;
    border: none;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 22px;
    color: #000000;
    outline: none;

    &::placeholder {
      line-height: 24px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 12px;
      color: #b6b6b6;
    }
  }

  .computer_pay_container_step_account_submit {
    margin-top: 12px;
    width: 100%;
    height: 46px;
    background: #e68608;
    border-radius: 23px;
    border: 1px solid #e68608;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &.is-loading {
      opacity: 0.6;
      pointer-events: none;
    }

    .computer_pay_container_step_account_submit_text {
      cursor: pointer;
    }
  }
}
</style>